import styled from "styled-components";
import { HelpOutline } from "@material-ui/icons";

const PopupHelpButton = styled(HelpOutline)`
  cursor: pointer;
  color: ${props => props.theme.greyEnterprise1};
`;

export default PopupHelpButton;
